module.exports = __webpack_public_path__ + "static/img/38.3d83409d.jpg";